export default __webpack_public_path__ + "static/media/wealthall.bd7a3c70.jpg";